import styled from '@emotion/styled';

export const BetBuilderLivePrice = styled('div', { label: 'BetBuilderLivePrice' })`
    font-weight: bold;
    margin: 5px 0 0 20px;
`;

export const OddsInput = styled('input', { label: 'OddsInput' })<{
  suspendedChange: boolean;
}>`
    ${({ suspendedChange }): string=> suspendedChange ? 'color: red' : ''};
    ${({ readOnly }): string => readOnly === true ? 'opacity: 0.4; cursor: default;' : ''};
`;

export const BetBuilderBetSelections = styled('ul', { label: 'BetBuilderBetSelections' })`
    padding: 0;
    padding-left: 16px;
    list-style: disc;
    margin-bottom: 5px;

    li {
        margin-bottom: 5px;

        &:last-of-type {
            margin-bottom: 0;
        }
    }
`;

export const BetBuilderBetSelection = styled('span', { label: 'BetBuilderBetSelection' })`
    display: flex;
    flex-flow: column;
    font-size: 14px;
    line-height: 1.29;
    margin-bottom: 1px;
    padding: 0 6px 0 2px;
`;

export const BetBuilderBetMarket = styled('span', { label: 'BetBuilderBetMarket' })`
    font-size: 10px;
`;

export const BetBuilderBetNameInfo = styled('div', { label: 'BetBuilderBetNameInfo' })`
    font-size: 10px;
    line-height: 1.4;
    display: flex;
    color: #767676;
    margin-left: 20px;
`;

export const BetNameWrapper = styled('div', { label: 'BetNameWrapper' })`
    display: inherit;
`;
export const InputAndBetNameWrapper = styled('div', { label: 'InputAndBetNameWrapper' })`
    display: flex;
    flex-direction: row;

    & > [type='checkbox'] {
        margin-bottom: auto;
    }
`;

